
















import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
/**
 * 2023.10.20 [2023L-04] add
 */
@Component
export default class VariableFileInput extends Vue {
  private privateInvaildMessage: string = '';
  private innerLabel: string = '';
  private rules: any;
  private clearable: boolean = false;
  private counter: string | boolean = false;
  // (ts)親コンポーネントからデータを受け取るpropsは@Propデコレータ
  @Prop({default: false}) private isgroup?: boolean;
  @Prop() private grouplabel?: string;
  @Prop() private label?: string;
  @Prop() private type?: string;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop({default: false}) private readonly?: boolean;
  @Prop({default: false}) private disabled?: boolean;
  @Prop() private maxlength?: string;
  @Prop() private invaildMessage?: string;

  @Emit('input')
  protected changeModelValue(modelValue: any) {
    if (modelValue === null) {
      return null;
    }
    return modelValue[0];
  }

  private created() {
    // ラベルの設定
    if (this.isgroup && this.label) {
      this.innerLabel = this.label;
    }
    // クリアボタンの設定
    this.clearable = !(this.readonly || this.disabled);
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // validationルールの設定
    this.rules = [
      // (value: any) => (this.isValidateRequiredFile(value)) || '必須項目です。',
      // (text: string) => (this.isValidateRequired(text)) || '必須項目です。',
      // (value: string) => (this.isValidate(value)) || this.privateInvaildMessage,
      ];
    // 文字数カウンタの設定
    if (this.maxlength) {
      this.counter = this.maxlength;
    }
  }
}
